import { render, staticRenderFns } from "./warnconfig.vue?vue&type=template&id=283024bb&scoped=true&"
import script from "./warnconfig.vue?vue&type=script&lang=js&"
export * from "./warnconfig.vue?vue&type=script&lang=js&"
import style0 from "./warnconfig.vue?vue&type=style&index=0&id=283024bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283024bb",
  null
  
)

export default component.exports